var module = angular.module('octopusApp.library');

module.controller('LifecyclePolicyEditDialogController', function($scope, busy, $uibModalInstance, policy) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.policy = policy;

  $scope.reset = function(policyItem) {
    if (policyItem.ShouldKeepForever) {
      policyItem.QuantityToKeep = 0;
    } else {
      policyItem.QuantityToKeep = 3;
    }
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.policy);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/controllers/lifecycle_policy_edit_dialog_controller.js
// module id = 451
// module chunks = 1